import { Redirect, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { userLogout } from "../../actions/actions";
import useUserData from "../../hooks/user/useUserData";

const CampaignGuard = ({ children }) => {
    const { campaign: urlCampaign } = useParams();
    const dispatch = useDispatch();

    const { isLoggedIn, campaign: authCampaign } = useUserData();

    if (isLoggedIn && authCampaign && authCampaign !== urlCampaign) {
        dispatch(userLogout());
        return <Redirect to={`/${urlCampaign}/`} />;
    }
    console.log("CampaignGuard rendered");

    return children;
};

export default CampaignGuard;
